import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

interface PerformanceData {
  name: string;
  completionRate: number;
  rating: number;
  responseTime: number;
}

const data: PerformanceData[] = [
  { name: 'Week 1', completionRate: 85, rating: 4.5, responseTime: 25 },
  { name: 'Week 2', completionRate: 88, rating: 4.6, responseTime: 22 },
  { name: 'Week 3', completionRate: 92, rating: 4.8, responseTime: 20 },
  { name: 'Week 4', completionRate: 90, rating: 4.7, responseTime: 18 },
];

const CustomXAxis = (props: any) => (
  <XAxis
    {...props}
    stroke="hsl(var(--muted-foreground))"
    fontSize={12}
    tickLine={false}
  />
);

const CustomYAxis = (props: any) => (
  <YAxis
    {...props}
    stroke="hsl(var(--muted-foreground))"
    fontSize={12}
    tickLine={false}
  />
);

export function PerformanceMetrics() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Performance Metrics</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[400px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
              <CustomXAxis dataKey="name" />
              <CustomYAxis yAxisId="left" />
              <CustomYAxis yAxisId="right" orientation="right" />
              <Tooltip
                content={({ active, payload, label }) => {
                  if (active && payload?.length) {
                    return (
                      <div className="rounded-lg border bg-background p-3 shadow-sm">
                        <div className="text-sm font-medium">{label}</div>
                        <div className="mt-1 space-y-1">
                          {payload.map((entry) => (
                            <div
                              key={entry.name}
                              className="flex items-center gap-2 text-sm"
                            >
                              <div
                                className="h-2 w-2 rounded-full"
                                style={{ backgroundColor: entry.color }}
                              />
                              <span className="text-muted-foreground">
                                {entry.name}: {entry.value}
                                {entry.name === 'Response Time' ? 'min' : 
                                  entry.name === 'Completion Rate' ? '%' : '★'}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  }
                  return null;
                }}
              />
              <Legend />
              <Line
                yAxisId="left"
                type="monotone"
                dataKey="completionRate"
                name="Completion Rate"
                stroke="hsl(var(--success))"
                strokeWidth={2}
                dot={{ r: 4 }}
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="rating"
                name="Rating"
                stroke="hsl(var(--warning))"
                strokeWidth={2}
                dot={{ r: 4 }}
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="responseTime"
                name="Response Time"
                stroke="hsl(var(--primary))"
                strokeWidth={2}
                dot={{ r: 4 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}